
import CryptoJS from "crypto-js";
import envconf from "../envConfig";

export const getImageByName = (productName: any): any => {
  switch (productName) {
    case "PZZ_Tuna":
      return "./../../assets/PizzaTuna.png";
    case "PZZ_Pepperoni":
      return "./../../assets/PizzaPepperoni.png";
    case "PZZ_Mexican":
      return "./../../assets/PizzaMexican.png";
    case "PZZ_Margherita":
      return "./../../assets/PizzaMargherita.png";

    default:
      return "./../../assets/PizzaTuna.png";
  }
  // return "./../../assets/PizzaTuna.png";
};

export const getPizzaName = (productName: any): any => {
  switch (productName) {
    case "PZZ_Tuna":
      return "Pizza Tuna";
    case "PZZ_Pepperoni":
      return "Pizza Pepperoni";
    case "PZZ_Mexican":
      return "Pizza Mexican";
    case "PZZ_Margherita":
      return "Pizza Margherita";
    case "PZZ_Vegetarian":
      return "Pizza Vegetarian";
    case "PZZ_4Season":
      return "Pizza 4 Season";
    case "PZZ_Start":
      return "Pizza Start";
    case "PZZ_Seafood":
      return "Pizza Seafood";

    default:
      return "Pizza";
  }
  // return "./../../assets/PizzaTuna.png";
};

// export const unitABV = (unit) => {
//   switch (productName) {
//     case "PZZ_Tuna":
//       return "Pizza Tuna";
//     case "PZZ_Pepperoni":
//       return "Pizza Pepperoni";
//     case "PZZ_Mexican":
//       return "Pizza Mexican";
//     case "PZZ_Margherita":
//       return "Pizza Margherita";
//     case "PZZ_Vegetarian":
//       return "Pizza Vegetarian";
//     case "PZZ_4Season":
//       return "Pizza 4 Season";
//     case "PZZ_Start":
//       return "Pizza Start";
//     case "PZZ_Seafood":
//       return "Pizza Seafood";

//     default:
//       return "Pizza";
//   }

// }

export function calculateTotal(items) {
  return items?.reduce((total, item) => {
    return (
      total + (item?.price * item.quantityInBasket * (100 - item?.sold)) / 100
    );
  }, 0);
}
export function calculateTotalInOrder(items) {
  return items?.reduce((total, item) => {
    return total + item.price * item.count;
  }, 0);
}
const MASTER_KEY = envconf.SECRET_KEY || "hzouhel";

const decryptWithKey = (encryptedValue: string, key: string): string | null => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedValue, key);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted || null;
  } catch (error) {
    console.error("Decryption failed:", error);
    return null;
  }
};

export const getFromLocalStorage = (key: string): string | null => {
  try {
    const encryptedValue = localStorage.getItem(key);

  

    return encryptedValue;
  } catch (err) {
    console.error("Failed to get or decrypt local storage key:", key, err);
    return null;
  }
};
